import { PickingDetailReport } from '../../../interfaces/DashBoard/DashBoard'
import { TypeBtn } from '../screens/PickingReportSearch/types/typeBtn'
import { PickingItemProps } from '../screens/PickingStatesSquare/interfaces'
import { actionTypes } from '../types/actionTypes'
import { PickingReportItems, SnackBar } from '../types/reducerTypes'

/*
Copyright 2022-06-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea logica de acciones reporte de picking
*/

export const pickingReportActions = () => {
  const setIsShowRoutes = (value: boolean): actionTypes => ({
    type: 'setIsShowRoutes',
    payload: value
  })
  const setSnackbar = (value: SnackBar): actionTypes => ({
    type: 'setSnackbar',
    payload: value
  })
  const setSelectPickingState = (value: PickingItemProps): actionTypes => ({
    type: 'setSelectPickingState',
    payload: value
  })
  const setSelectedZone = (value: number): actionTypes => ({
    type: 'setSelectedZone',
    payload: value
  })
  const setBtnType = (value: TypeBtn): actionTypes => ({
    type: 'setBtnType',
    payload: value
  })
  const setFilteredDate = (value: string): actionTypes => ({
    type: 'setFilteredDate',
    payload: value
  })
  const setPickingItems = (value: PickingReportItems[]): actionTypes => ({
    type: 'setPickingItems',
    payload: value
  })
  const setCardsItems = (value: PickingItemProps[]): actionTypes => ({
    type: 'setCardsItems',
    payload: value
  })

  const setPickingDetailItems = (
    value: PickingDetailReport[]
  ): actionTypes => ({
    type: 'setPickingDetailItems',
    payload: value
  })

  const setLoading = (value: boolean): actionTypes => ({
    type: 'setLoading',
    payload: value
  })

  return {
    setIsShowRoutes,
    setSelectPickingState,
    setSelectedZone,
    setBtnType,
    setFilteredDate,
    setPickingItems,
    setCardsItems,
    setSnackbar,
    setPickingDetailItems,
    setLoading
  }
}
